import { styled } from "@mui/material/styles";
import { List } from "@mui/material";

export const SubMenuWrapper = styled(List)(
  ({ theme }) => `
      &.MuiList-root {
        padding: 0;
        font-weight: normal !important;
      }
  
      .MuiListItem-root {
        width: 100% !important;
        padding: 0 !important;
  
        .MuiButton-root {
          display: flex;
          color: ${theme.sidebar.menuItemColor};
          background-color: ${theme.sidebar.menuItemBg};
          width: 100%;
          justify-content: flex-start;
          font-size: ${theme.typography.pxToRem(14)};
          font-weight: 400;
          padding-top: ${theme.spacing(1.2)};
          padding-bottom: ${theme.spacing(1.2)};
          padding-left: ${theme.spacing(3.2)};
          position: relative;
          border-radius: 0;
  
          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(4)};
            .MuiBadge-standard {
              background: ${theme.colors.primary.main};
              font-size: ${theme.typography.pxToRem(9)};
              font-weight: bold;
              text-transform: uppercase;
              color: ${theme.palette.primary.contrastText};
            }
          }
  
          .MuiButton-startIcon {
            font-size: ${theme.typography.pxToRem(26)};
            margin-right: ${theme.spacing(1.5)};
            color: ${theme.sidebar.menuItemIconColor};
            transition: color 0.3s ease;
          }
  
          .MuiButton-endIcon {
            margin-left: auto;
            font-size: ${theme.typography.pxToRem(22)};
            transition: color 0.3s ease;
          }
  
          &.Mui-active {
            background-color: ${theme.sidebar.menuItemBgActive};     
            color: ${theme.sidebar.menuItemColorActive} !important;
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.sidebar.menuItemColorActive} !important;
              svg {
                path, circle {
                  filter: brightness(0) invert(1) ;
                }
              }
            }
          }
  
          &:hover {
            background-color: ${theme.sidebar.menuItemBgActive};
            color: ${theme.sidebar.menuItemColorActive};
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.sidebar.menuItemIconColorActive};
              svg {
                path, circle, rect {
                  filter: brightness(0) invert(1);
                }
              }
            }
          }
        }
  
        &.Mui-children {
          flex-direction: column;
          position: relative;
  
          &::after {
            content: '';
            display: block;
            width: 14px;
            height: 14px;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M9 1L5 5L1 1' stroke='%23035344' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            right: ${theme.spacing(3)};
            transition: transform 0.3s ease, filter 0.3s ease;
            top: ${theme.spacing(2)};
          }
  
          &.Mui-active::after {
            transform: rotate(180deg) !important;
            filter: brightness(0) invert(1) !important;
          }
  
          &:hover::after {
            filter: brightness(0) invert(1);
            color: ${theme.sidebar.menuItemIconColorActive};
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M9 1L5 5L1 1' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
          }
             &:has(.MuiCollapse-entered)::after{
    transform: rotate(180deg) !important;
            filter: brightness(0) invert(1) !important;
             }
        }
      }
  
      .MuiCollapse-root {
        width: 100%;
         &.Mui-active {
            background-color: ${theme.sidebar.menuItemBgActive};     
            color: ${theme.sidebar.menuItemColorActive} !important;
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.sidebar.menuItemColorActive} !important;
              svg {
                path, circle {
                   filter: none !important;
                }
              }
            }
          }
        .MuiList-root {
          padding: ${theme.spacing(1, 0)};
        }
        .MuiListItem-root {
          .MuiButton-root {
            font-size: ${theme.typography.pxToRem(12)};
            padding: ${theme.spacing(1, 2, 1, 4.5)};
            margin-left: ${theme.spacing(2.5)};
            border-radius: 5px 0 0 5px;
  
            &.Mui-active {
              background-color: #D3E3E0 !important;
              color: ${theme.colors.primary.main} !important;
              .MuiButton-startIcon,
              .MuiButton-endIcon {
                color: ${theme.colors.primary.main} !important;
                svg {
                  path, circle {
                    filter: none;
                  }
                }
              }
            }
  
            &:hover {
              background-color: ${theme.sidebar.menuItemBgActive};
              color: ${theme.sidebar.menuItemColorActive};
            }
          }
        }
      }
    `
);
